import { render, staticRenderFns } from "./StudyNewPageTopicSelector.vue?vue&type=template&id=724ca989&scoped=true"
import script from "./StudyNewPageTopicSelector.vue?vue&type=script&lang=js"
export * from "./StudyNewPageTopicSelector.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageTopicSelector.vue?vue&type=style&index=0&id=724ca989&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724ca989",
  null
  
)

export default component.exports